import * as React from "react";
import { useState } from "react";
import * as FormsUtils from "util/FormsUtils";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import Input from "components/bootstrap/Input";
import useSaveViewFormControls from "views/hooks/useSaveViewFormControls";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
const DashboardPropertiesModal = ({
  onClose,
  onSave,
  show,
  view,
  title: modalTitle,
  submitButtonText,
  dashboardId = null
}) => {
  const [updatedDashboard, setUpdatedDashboard] = useState(view);
  const [sharePayload, setSharePayload] = useState(null);
  const pluggableFormComponents = useSaveViewFormControls();
  const _onChange = (event) => {
    const { name } = event.target;
    let value = FormsUtils.getValueFromInput(event.target);
    const trimmedValue = value.trim();
    if (trimmedValue === "") {
      value = trimmedValue;
    }
    switch (name) {
      case "title":
        setUpdatedDashboard((_updatedDashboard) => _updatedDashboard.toBuilder().title(value).build());
        break;
      case "summary":
        setUpdatedDashboard((_updatedDashboard) => _updatedDashboard.toBuilder().summary(value).build());
        break;
      case "description":
        setUpdatedDashboard((_updatedDashboard) => _updatedDashboard.toBuilder().description(value).build());
        break;
      default:
    }
  };
  const _onSave = (e) => {
    e.stopPropagation();
    onSave(updatedDashboard, sharePayload);
    onClose();
  };
  return /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show,
      title: modalTitle,
      "data-telemetry-title": "Dashboard Properties",
      onCancel: onClose,
      onSubmitForm: _onSave,
      submitButtonText,
      bsSize: "large"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "title",
        type: "text",
        name: "title",
        label: "Title",
        help: "The title of the dashboard.",
        required: true,
        onChange: _onChange,
        value: updatedDashboard.title
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "summary",
        type: "text",
        name: "summary",
        label: "Summary",
        help: "A helpful summary of the dashboard.",
        onChange: _onChange,
        value: updatedDashboard.summary
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "description",
        type: "textarea",
        name: "description",
        label: "Description",
        help: "A longer, helpful description of the dashboard and its functionality.",
        onChange: _onChange,
        value: updatedDashboard.description
      }
    ), dashboardId !== view.id && /* @__PURE__ */ React.createElement(
      EntityCreateShareFormGroup,
      {
        description: "Search for a User or Team to add as collaborator on this dashboard.",
        entityType: "dashboard",
        entityTitle: "",
        onSetEntityShare: (payload) => setSharePayload(payload)
      }
    ), pluggableFormComponents == null ? void 0 : pluggableFormComponents.map(({ component: Component, id }) => Component && /* @__PURE__ */ React.createElement(Component, { key: id })))
  );
};
export default DashboardPropertiesModal;
